import { render } from "./PanelReservas.vue?vue&type=template&id=cac006dc&scoped=true"
import script from "./PanelReservas.vue?vue&type=script&lang=js"
export * from "./PanelReservas.vue?vue&type=script&lang=js"

import "./PanelReservas.vue?vue&type=style&index=0&id=cac006dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac006dc"]])

export default __exports__